import GenericTable from "../../../../components/GenericTable";
import GenericTableElement from "../../../../components/GenericTableElement";
import { Notification } from "../../../../types/types";
import { NOTIFICATIONS_TABLE_COLUMNS } from "../config/tables";
import { Table } from "@chakra-ui/react";

type Props = {
  isLoading: boolean;
  notifications: Notification[];
};

const NotificationsTable = ({
  isLoading,
  notifications,
}: Props): JSX.Element => {
  return (
    <GenericTable isLoading={isLoading} columns={NOTIFICATIONS_TABLE_COLUMNS}>
      {notifications.map((notification, index) => {
        return (
          <Table.Row key={index}>
            {NOTIFICATIONS_TABLE_COLUMNS.map((column) => (
              <GenericTableElement
                key={`${index}-${column.key}`}
                value={column.value(notification)}
                badge={column.key === "type"}
                statusIcon={column.key === "status"}
                formatNumber={column.key === "amount" || column.key === "fee"}
                formatDatetimeUtc={column.key === "createdAt"}
              />
            ))}
          </Table.Row>
        );
      })}
    </GenericTable>
  );
};

export default NotificationsTable;
